import { render, staticRenderFns } from "./LandingPageDekstopView.vue?vue&type=template&id=611b14f3&scoped=true&"
import script from "./LandingPageDekstopView.vue?vue&type=script&lang=js&"
export * from "./LandingPageDekstopView.vue?vue&type=script&lang=js&"
import style0 from "../../../assets/style/base.css?vue&type=style&index=0&id=611b14f3&scoped=true&lang=css&"
import style1 from "../../../assets/style/bootstarp-grid.css?vue&type=style&index=1&id=611b14f3&scoped=true&lang=css&"
import style2 from "./LandingPageDekstopView.vue?vue&type=style&index=2&id=611b14f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611b14f3",
  null
  
)

export default component.exports